function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBazarLittleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#fefffe",
    d: "M 91.5,6.5 C 106.947,4.30697 118.447,9.97363 126,23.5C 130.978,33.9555 135.812,44.4555 140.5,55C 152.543,57.1183 164.543,59.4516 176.5,62C 181.029,63.5139 185.195,65.6806 189,68.5C 188.342,93.7803 184.009,118.447 176,142.5C 156.982,183.93 124.815,201.096 79.5,194C 51.1879,186.356 31.6879,168.856 21,141.5C 13.1018,117.776 8.76851,93.4427 8,68.5C 14.2269,64.3103 21.0602,61.4769 28.5,60C 38.1252,58.1727 47.7918,56.6727 57.5,55.5C 61.5669,43.3645 66.7336,31.6978 73,20.5C 77.9561,14.0195 84.1228,9.35288 91.5,6.5 Z M 94.5,24.5 C 100.07,23.4161 104.57,25.0827 108,29.5C 112.407,37.0554 116.24,44.8888 119.5,53C 105.5,53.6667 91.5,53.6667 77.5,53C 80.4619,46.9084 83.2953,40.7418 86,34.5C 88.6686,31.0003 91.502,27.667 94.5,24.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBazarLittleLogo);
export default __webpack_public_path__ + "static/media/bazar-little_logo.215fcc52a064923c65416aa9bbc42ada.svg";
export { ForwardRef as ReactComponent };